var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_218_652",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_218_652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.25 5V12.125C13.25 12.4344 13.1398 12.6992 12.9195 12.9195C12.6992 13.1398 12.4344 13.25 12.125 13.25H3.875C3.56563 13.25 3.30078 13.1398 3.08047 12.9195C2.86016 12.6992 2.75 12.4344 2.75 12.125V3.875C2.75 3.56563 2.86016 3.30078 3.08047 3.08047C3.30078 2.86016 3.56563 2.75 3.875 2.75H11L13.25 5ZM8 11.5625C8.46875 11.5625 8.86719 11.3984 9.19531 11.0703C9.52344 10.7422 9.6875 10.3438 9.6875 9.875C9.6875 9.40625 9.52344 9.00781 9.19531 8.67969C8.86719 8.35156 8.46875 8.1875 8 8.1875C7.53125 8.1875 7.13281 8.35156 6.80469 8.67969C6.47656 9.00781 6.3125 9.40625 6.3125 9.875C6.3125 10.3438 6.47656 10.7422 6.80469 11.0703C7.13281 11.3984 7.53125 11.5625 8 11.5625ZM4.625 6.875H9.875V4.625H4.625V6.875Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.f4dd10bd88feca08bbf68086cca3a52f.svg";
export { ForwardRef as ReactComponent };